import { render, staticRenderFns } from "./AccountingYear.vue?vue&type=template&id=4db4ceeb&scoped=true"
import script from "./AccountingYear.vue?vue&type=script&lang=js"
export * from "./AccountingYear.vue?vue&type=script&lang=js"
import style0 from "./AccountingYear.vue?vue&type=style&index=0&id=4db4ceeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db4ceeb",
  null
  
)

export default component.exports